// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  /* responsive tablet */
  @media (max-width: 1100px) {
    .container .contact-info{
      display: none;
    }
  
    .container {
      padding: 0 30px; 
      box-sizing: border-box;
    }
  
    /* HEADER START */
    nav ul {
      display: flex;
      justify-content: center; 
  
    }
  
    nav li {
      margin: 0 15px; 
    }
  
  
    .hamburger-menu {
      display: none;
    }
    /* HEADER END */
  
  /* HERO START */
  
  .hero-text {
    position: absolute;
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
    text-align: center; 
    color: white; 
    width: 65%;
  
    padding: 35px;
  }
  
  .hero-text h1 {
    font-size: 3rem; 
    margin-bottom: 10px; 
  }
  
  .hero-text p {
    font-size: 20px; 
  }
  
  .hero-text .explore-now-cta {
    font-size: 18px;
  }
  
  
  .hero-image img{
    width:100%;
    height:100vh;
    object-fit: cover;
  }
  /* HERO END */
  
    /* EXPLORE START */
    .explore-content {
      grid-template-columns: repeat(2, 1fr); 
    }
  
    .explore-item {
      width: auto; 
      margin-bottom: 30px; 
    }
    /* EXPLORE END */
  
    /* FOOTER START */
    .footer-navigation {
      display: flex; 
      justify-content: center; 
      margin-top: 20px;
    }
  
    .footer-navigation ul li {
      margin: 0 10px; 
    }
  
    .footer-text p {
      margin-top: 20px;
    }
    /* FOOTER END */
    
  /* DETAIL PAGE START */
  /* Customer review start*/
  .review-wrapper{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  /* Customer review end */

  /* DETAIL PAGE END */
  }
  

/* responsive mobile */
@media (max-width: 600px) {

    .container {
      max-width: 1400px;
      margin: 0 auto;
      padding: 10px 10px;
    }
  
  
    /* HEADER START */
    header{
        gap: 10px;
    }

    header .logo {
      font-size: 24px;
      padding: 10px;
    }
    nav ul {
      display: none;
      position: absolute;
      top: 0;
      right: 4px; 
      width: 200px; 
      background-color: #fff; 
      padding: 20px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
      transition: right 0.3s ease; 
  
      min-width: 44px;
      min-height: 44px;
    }
  
    nav ul.menu-open {
      right: 0; 
    }
  
  
    #hamburgerButton {
      width:44px;
      height: 44px;
      z-index: 1000;
      display: block;
      font-size: 24px;
      cursor: pointer;
    }
    
  
    .contact-info {
      display: none;
    }
  
    #hamburgerButton{
      display: block;
      font-size: 24px;
    }
  /* HEADER END */
  
  /* HERO START */
  
  .hero{
    z-index: -1;
  }
  
  .hero-text {
    position: absolute;
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
    text-align: center; 
    color: white; 
    width: 70%;
  }
  
  .hero-text h1 {
    font-size: 2rem; 
    margin-bottom: 10px; 
  }
  
  .hero-text p {
    font-size: 18px; 
  }
  
  .hero-text .explore-now-cta {
    font-size: 16px;
  }
  
  .hero-image img {
    width: 100%;
    height: 100vh; 
  }
  /* HERO END */
  
  /* EXPLORE START */
  .explore {
    margin-top: 50px;
    text-align: center;
  }
  .explore-text {
    margin-top: 0px;
    font-size: 24px;
  }
  
  .explore-description{
    font-size: 16px;
  }
  
  .explore-content {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  
  .explore-item {
    margin-bottom: 20px;
  }
  /* EXPLORE END */
  
  /* FOOTER START */
  
  
  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  
  .footer-navigation {
    display:none;
  }
  
  
  /* FOOTER END */

  /* DETAIL PAGE START */
  
  .restaurant-info{
    flex-direction: column;
    
  }

  .restaurant-image {
    margin-right: 0;
  }

  .restaurant-menu {
    display: flex;
    margin-top: 20px;

    flex-direction: column;
  }
  
  /* Customer review start*/
  .review-wrapper{
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  /* Customer review end */

  /* DETAIL PAGE END */
  
}
  

`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":";EACE,sBAAsB;EACtB;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;MACf,sBAAsB;IACxB;;IAEA,iBAAiB;IACjB;MACE,aAAa;MACb,uBAAuB;;IAEzB;;IAEA;MACE,cAAc;IAChB;;;IAGA;MACE,aAAa;IACf;IACA,eAAe;;EAEjB,eAAe;;EAEf;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,UAAU;;IAEV,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;;EAGA;IACE,UAAU;IACV,YAAY;IACZ,iBAAiB;EACnB;EACA,aAAa;;IAEX,kBAAkB;IAClB;MACE,qCAAqC;IACvC;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;IACA,gBAAgB;;IAEhB,iBAAiB;IACjB;MACE,aAAa;MACb,uBAAuB;MACvB,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,gBAAgB;IAClB;IACA,eAAe;;EAEjB,sBAAsB;EACtB,yBAAyB;EACzB;IACE,aAAa;IACb,qCAAqC;EACvC;EACA,wBAAwB;;EAExB,oBAAoB;EACpB;;;AAGF,sBAAsB;AACtB;;IAEI;MACE,iBAAiB;MACjB,cAAc;MACd,kBAAkB;IACpB;;;IAGA,iBAAiB;IACjB;QACI,SAAS;IACb;;IAEA;MACE,eAAe;MACf,aAAa;IACf;IACA;MACE,aAAa;MACb,kBAAkB;MAClB,MAAM;MACN,UAAU;MACV,YAAY;MACZ,sBAAsB;MACtB,aAAa;MACb,2CAA2C;MAC3C,2BAA2B;;MAE3B,eAAe;MACf,gBAAgB;IAClB;;IAEA;MACE,QAAQ;IACV;;;IAGA;MACE,UAAU;MACV,YAAY;MACZ,aAAa;MACb,cAAc;MACd,eAAe;MACf,eAAe;IACjB;;;IAGA;MACE,aAAa;IACf;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;EACF,eAAe;;EAEf,eAAe;;EAEf;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;EACA,aAAa;;EAEb,kBAAkB;EAClB;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qCAAqC;EACvC;;EAEA;IACE,mBAAmB;EACrB;EACA,gBAAgB;;EAEhB,iBAAiB;;;EAGjB;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;;EAGA,eAAe;;EAEf,sBAAsB;;EAEtB;IACE,sBAAsB;;EAExB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;;IAEhB,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,qCAAqC;EACvC;EACA,wBAAwB;;EAExB,oBAAoB;;AAEtB","sourcesContent":["\n  /* responsive tablet */\n  @media (max-width: 1100px) {\n    .container .contact-info{\n      display: none;\n    }\n  \n    .container {\n      padding: 0 30px; \n      box-sizing: border-box;\n    }\n  \n    /* HEADER START */\n    nav ul {\n      display: flex;\n      justify-content: center; \n  \n    }\n  \n    nav li {\n      margin: 0 15px; \n    }\n  \n  \n    .hamburger-menu {\n      display: none;\n    }\n    /* HEADER END */\n  \n  /* HERO START */\n  \n  .hero-text {\n    position: absolute;\n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%); \n    text-align: center; \n    color: white; \n    width: 65%;\n  \n    padding: 35px;\n  }\n  \n  .hero-text h1 {\n    font-size: 3rem; \n    margin-bottom: 10px; \n  }\n  \n  .hero-text p {\n    font-size: 20px; \n  }\n  \n  .hero-text .explore-now-cta {\n    font-size: 18px;\n  }\n  \n  \n  .hero-image img{\n    width:100%;\n    height:100vh;\n    object-fit: cover;\n  }\n  /* HERO END */\n  \n    /* EXPLORE START */\n    .explore-content {\n      grid-template-columns: repeat(2, 1fr); \n    }\n  \n    .explore-item {\n      width: auto; \n      margin-bottom: 30px; \n    }\n    /* EXPLORE END */\n  \n    /* FOOTER START */\n    .footer-navigation {\n      display: flex; \n      justify-content: center; \n      margin-top: 20px;\n    }\n  \n    .footer-navigation ul li {\n      margin: 0 10px; \n    }\n  \n    .footer-text p {\n      margin-top: 20px;\n    }\n    /* FOOTER END */\n    \n  /* DETAIL PAGE START */\n  /* Customer review start*/\n  .review-wrapper{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n  }\n  /* Customer review end */\n\n  /* DETAIL PAGE END */\n  }\n  \n\n/* responsive mobile */\n@media (max-width: 600px) {\n\n    .container {\n      max-width: 1400px;\n      margin: 0 auto;\n      padding: 10px 10px;\n    }\n  \n  \n    /* HEADER START */\n    header{\n        gap: 10px;\n    }\n\n    header .logo {\n      font-size: 24px;\n      padding: 10px;\n    }\n    nav ul {\n      display: none;\n      position: absolute;\n      top: 0;\n      right: 4px; \n      width: 200px; \n      background-color: #fff; \n      padding: 20px;\n      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n      transition: right 0.3s ease; \n  \n      min-width: 44px;\n      min-height: 44px;\n    }\n  \n    nav ul.menu-open {\n      right: 0; \n    }\n  \n  \n    #hamburgerButton {\n      width:44px;\n      height: 44px;\n      z-index: 1000;\n      display: block;\n      font-size: 24px;\n      cursor: pointer;\n    }\n    \n  \n    .contact-info {\n      display: none;\n    }\n  \n    #hamburgerButton{\n      display: block;\n      font-size: 24px;\n    }\n  /* HEADER END */\n  \n  /* HERO START */\n  \n  .hero{\n    z-index: -1;\n  }\n  \n  .hero-text {\n    position: absolute;\n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%); \n    text-align: center; \n    color: white; \n    width: 70%;\n  }\n  \n  .hero-text h1 {\n    font-size: 2rem; \n    margin-bottom: 10px; \n  }\n  \n  .hero-text p {\n    font-size: 18px; \n  }\n  \n  .hero-text .explore-now-cta {\n    font-size: 16px;\n  }\n  \n  .hero-image img {\n    width: 100%;\n    height: 100vh; \n  }\n  /* HERO END */\n  \n  /* EXPLORE START */\n  .explore {\n    margin-top: 50px;\n    text-align: center;\n  }\n  .explore-text {\n    margin-top: 0px;\n    font-size: 24px;\n  }\n  \n  .explore-description{\n    font-size: 16px;\n  }\n  \n  .explore-content {\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n  \n  .explore-item {\n    margin-bottom: 20px;\n  }\n  /* EXPLORE END */\n  \n  /* FOOTER START */\n  \n  \n  .footer-content {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n  }\n  \n  .footer-navigation {\n    display:none;\n  }\n  \n  \n  /* FOOTER END */\n\n  /* DETAIL PAGE START */\n  \n  .restaurant-info{\n    flex-direction: column;\n    \n  }\n\n  .restaurant-image {\n    margin-right: 0;\n  }\n\n  .restaurant-menu {\n    display: flex;\n    margin-top: 20px;\n\n    flex-direction: column;\n  }\n  \n  /* Customer review start*/\n  .review-wrapper{\n    display: grid;\n    grid-template-columns: repeat(1, 1fr);\n  }\n  /* Customer review end */\n\n  /* DETAIL PAGE END */\n  \n}\n  \n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
